import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Self-hosted fonts (WS-A): IBM Plex Sans + JetBrains Mono, bundled from npm —
// no runtime font CDNs. Family names registered: 'IBM Plex Sans Variable',
// 'JetBrains Mono Variable' (referenced by --font-primary / --font-mono).
import '@fontsource-variable/ibm-plex-sans';
import '@fontsource-variable/jetbrains-mono';
import './styles/colors_and_type.css';
import './styles/fonts.css';
import './styles/app.css';
import { initTheme } from './styles/theme';
import { reloadForStaleChunk } from './routes/lazyWithRetry';
import App from './App';

initTheme();

// Vite fires this when a module preload / dynamic import 404s — typically a stale chunk after a
// new deploy. Recover by reloading to the fresh build (guarded against reload loops).
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForStaleChunk()) event.preventDefault();
});

// Start MSW only when mocks are enabled — dynamically imported so MSW, the
// handlers and seed data are excluded from production bundles entirely.
async function enableMocking(): Promise<void> {
  if (import.meta.env.VITE_USE_MOCKS !== 'true') return;
  const { worker } = await import('./mocks/browser');
  await worker.start({
    onUnhandledRequest: 'bypass',
    serviceWorker: { url: `${import.meta.env.BASE_URL}mockServiceWorker.js` },
  });
}

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
